/* eslint-disable */
import React from 'react';
import { ImageSelect } from '../_shared/ImageSelect';

// Women's styles — the men's set (fade / undercut / pompadour / manBun / slickBack)
// came from the hairstyle funnel this one was copied from and did not describe any of
// the photos. Ids double as the tile file names in female/hairstyleWomenStyleLike/.
const OPTIONS = [
  { id: 'boxBraids' }, { id: 'curlyBob' }, { id: 'shag' }, { id: 'curlyVolume' }, { id: 'pixie' }, { id: 'bluntBob' },
  { id: 'longLayers' }, { id: 'waves' }, { id: 'sleekBob' }, { id: 'buzz' }, { id: 'braid' }, { id: 'other' },
];

function Page() {
  return (
    <ImageSelect
      page="hairstyle-women-style-like"
      progress={26}
      field="hairstyleWomenStyleLike"
      setter="setHairstyleWomenStyleLike"
      ns="hairstyleWomenStyleLike"
      options={OPTIONS}
      hasSubtitle
    />
  );
}

export default Page;
